import styled from 'styled-components'
import bgImg from './assets/bg.png'

export const Container = styled.div`
  align-items: flex-end;
  background-color: #FFF;
  display: flex;
  overflow: hidden;
  padding: 80px 24px 0;
  position: relative;

  @media (min-width: 912px) {
    padding-inline: 72px;
  }

  @media (max-width: 568px) {
    padding-block: 40px 0;
  }
`

export const Background = styled.div`
  background-color: #FCF8EF;
  border-radius: 32px 32px 0 0;
  bottom: 0;
  height: 162px;
  left: 0;
  position: absolute;
  right: 0;
  width: 100%;
`

export const Content = styled.div`
  align-items: center;
  background-color: #084F43;
  background-image: url(${bgImg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  justify-content: space-around;
  margin-inline: auto;
  max-width: 1366px;
  padding: 56px 8px;
  width: 100%;
  z-index: 1;

  & > h1 {
    color: #FFF;
    font-size: 1.5rem;
    font-weight: 500;
    text-align: center;
  }

  @media (max-width: 569px) {
    gap: 24px;
    padding-block: 40px;
  }
`

export const NumbersGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  justify-content: center;
  width: 100%;

  @media (max-width: 569px) {
    gap: 24px 8px;
  }
`
